export const version = 'v2.2.4-2044-g4e533f0af'
